<template>
  <section class="card border-primary mb-4" aria-label="Kopie prüfen">
    <div class="card-body">
      <h5>{{ title }} kopieren: {{ sourceName }}</h5>
      <p>{{ scope }}</p>
      <p>Benutzer und Mitgliedschaften werden nicht übernommen.</p>
      <label class="form-label" for="definitionCopyName">Name der Kopie</label>
      <input id="definitionCopyName" v-model="name" class="form-control mb-3" maxlength="150" :disabled="busy" />
      <p class="mb-1">Diese {{ assignmentLabel }} werden übernommen:</p>
      <ul v-if="assignments.length"><li v-for="item in assignments" :key="item.id">{{ item.label }}</li></ul>
      <p v-else class="text-muted">Keine Zuordnungen.</p>
      <div v-if="error" role="alert" class="alert alert-danger">{{ error }}</div>
      <button class="btn btn-primary me-2" :disabled="busy || !name.trim()" @click="$emit('confirm', name.trim())">Kopie mit diesen Zuordnungen erstellen</button>
      <button class="btn btn-outline-secondary" :disabled="busy" @click="$emit('cancel')">Abbrechen</button>
    </div>
  </section>
</template>

<script setup>
/* global defineProps, defineEmits */
import { ref } from "vue";
const props = defineProps({
  title: { type: String, required: true },
  sourceName: { type: String, required: true },
  scope: { type: String, required: true },
  assignmentLabel: { type: String, required: true },
  assignments: { type: Array, required: true },
  busy: { type: Boolean, default: false },
  error: { type: String, default: "" },
});
defineEmits(["confirm", "cancel"]);
const name = ref(`${props.sourceName} (Kopie)`);
</script>
